/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class NotificationsApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Patch notification
     * @param id 
     * @param body 
     */
    public patchNotification(id?: number, body?: models.ApiPatchUsersCurrentNotifications, __unused?: any): Observable<{}> {
        const path = '/users/current/notifications/{id}'
                    .replace('{' + 'id' + '}', String(id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Patch'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<any>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
                body,
            );
    }

    /**
     * Get notifications
     * @param page 
     */
    public getNotifications(page?: number, __unused?: any): Observable<PagedArray<models.ApiNotification>> {
        const path = '/users/current/notifications';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 
        if (page !== undefined) {
            queryParameters['page'] = <any>page;
        }


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiNotification>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
